import { useDictionary } from '../../../../../../../../utilities/hooks/UseDictionary';
import ParticipantItem from './ParticipantItem';
import React from 'react';
import PropTypes from 'prop-types';
import ProfileImage from '../../../../../../common/ProfileImage';
import { NavigatorPaths } from '../../../../../../../../assets/dictionaries/NavigatorPaths';
import { useHistory } from 'react-router-dom';

const ParticipantsAndAddons = ({ details }) => {
	const dictionary = useDictionary();
	const history = useHistory();
	const bookingParticipantsAndAddons = details?.booking_participants && details.booking_participants.length > 0;

	const getParticipantsQuantity = () => {
		let quantity = 0;
		details?.participants.map((group) => {
			quantity += group.quantity;
		});

		let diff = parseInt(details?.slot?.capacity) - parseInt(details?.slot?.booked);

		return (
			quantity +
			' ' +
			(quantity > 1 ? dictionary.spots : dictionary.spot) +
			' (' +
			diff.toString() +
			' ' +
			(diff === 1 ? dictionary.spot : dictionary.spots) +
			' ' +
			dictionary.available +
			')'
		);
	};

	const BookingPaticipants = ({ participant,index }) => {
		return (
			<div
				key={index}
				className="participant-row-container"
				style={{ marginBottom: (window.innerWidth > 767 ? '16px' : '8px') }}
			>
				<div className='d-flex items-center'>
					<ProfileImage name={participant.name} photo={participant?.avatar_url} size={{ width: 40, height: 40,fontSize: 14, lineHeight: 16 }}/>
					<h4
						style={{ fontWeight: 'normal', minWidth: '164px', marginLeft: '8px' }}
						className={`${participant?.contact_id ? ' cursor-pointer text-with-underline' :''}`}
						onClick={participant?.contact_id ? () => {history.push(`/${NavigatorPaths.admin_provider_customers.path}/${participant.contact_id}`)} : null}
					>
						{participant.name ? participant.name : `${dictionary.participant} ${index+1}`}
					</h4>
					<h4
						style={{ fontWeight: 'normal', minWidth: '164px', opacity: '0.6' }}
					>
						{participant.participant_group}
					</h4>
				</div>
			</div>
		);
	};

	return (
		<div className="detail-tab-container thin-scrollbar fade-on-load">
			<div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '20px', textAlign: 'end' }}
			>
				<h3 data-testid="participant-groups-header">
					{dictionary.participants}
				</h3>
				<div
					style={{ fontWeight: 'normal', opacity: '0.6' }}
					className="booking-number"
				>
					{getParticipantsQuantity()}
				</div>
			</div>
			{!bookingParticipantsAndAddons && details?.participants?.map((participant) => (
				<ParticipantItem key={participant.id} participant={participant} />
			))}
			{
				bookingParticipantsAndAddons && details?.booking_participants?.map((participant,index) => (
					<BookingPaticipants key={participant.id} participant={participant} index={index}/>
				))
			}
			{/* <AddButtonSquare isRound={true} label={dictionary.add_new_participant}/>*/}

			{/*<div className='participant-row-container' style={{justifyContent: 'space-between', marginBottom:'20px'}}>
            <h3 style={{marginTop:'36px'}}>{dictionary.add_ons}</h3>
            <div style={{fontWeight: 'normal', opacity: '0.6'}}
                 className='booking-number'>{details.add_ons.length.toString() + ' ' + dictionary.add_ons}</div>
        </div>
        {details.add_ons.map(addon =>
            <AddonItem addon={addon}/>
        )}*/}
		</div>
	);
};

ParticipantsAndAddons.propTypes = {
	details: PropTypes.object
};

export default ParticipantsAndAddons;
